import { defineComponent as _defineComponent } from 'vue'
import BaseChip from "@/components-UI/BaseChip.vue";
import SvgStar from "@/assets/icons/star.svg";
import SvgTrue from "@/assets/icons/true-icon.svg";
import SvgFalse from "@/assets/icons/false-icon.svg";
import BaseAutocomplete from "@/components/base/design/BaseAutocomplete.vue";
import BaseSelect from "@/components/base/design/BaseSelect.vue";
import Status from "@/components/base/Status.vue";
import MessengerSelect from "@/components/base/form/MessengerSelect.vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import PhoneNumberInput from "@/components/base/PhoneNumberInput.vue";
import BaseButton from "@/components-UI/BaseButton.vue";
import BaseDateTimePicker from "@/components-UI/BaseDateTimePicker.vue";
import TagSelect from "@/components/base/TagSelect.vue";
import {
    AFFILIATE_INFO_EDIT_TYPE,
    AFFILIATE_INFO_TYPE,
    IAffiliateInfoItem,
} from "@/components/affiliate/affiliateMainInfo/types";
import BaseChipCollection from "@/components-UI/BaseChipCollection.vue";
import { computed, ref, watch } from "vue";
import { useCopyText } from "@/utils/copyText";
import { subYears } from 'date-fns';
import BaseInput from "@/components-UI/BaseInput.vue";
import ListItemText from "@/components-UI/list/items/ListItemText.vue";
import BaseInputNumber from "@/components-UI/BaseInputNumber.vue";

interface Props {
    item: IAffiliateInfoItem;
    isEdit: boolean;
    itemKey: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateMainInfoItem',
  props: {
    item: null,
    isEdit: { type: Boolean },
    itemKey: null
  },
  setup(__props: any) {

const props = __props as {
    item: IAffiliateInfoItem;
    isEdit: boolean;
    itemKey: string;
}



// -- Messenger
const messengerText = ref(null);
const messengerStyle = ref('');

const setMessengerStyle = () => {
    const messenger = messengerText.value as Element;
    messengerStyle.value = isNotNeedStyle ? '' : `width: ${messenger?.clientWidth! - 10}px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: pointer`;
};

watch(() => messengerText.value, (value) => {
    if (!!value) {
        setTimeout(() => {
            setMessengerStyle();
        }, 500);
    } else {
        messengerStyle.value = '';
    }
});

// -- Just text
const textEl = ref(null);

const isShowTooltip = computed(() => {
    if (props.item.type !== AFFILIATE_INFO_TYPE.TEXT) return false;
    const el = textEl?.value!;
    if (!el) return false;
    const lineHeight = Number(window.getComputedStyle(el).lineHeight.replace('px', '')) + 1;
    const factHeight = el.clientHeight;
    return lineHeight < factHeight;
});

// -- Copy
const copyValue = () => {
    if (props.item.type !== AFFILIATE_INFO_TYPE.MESSENGER || props.isEdit) return;
    useCopyText(props.item.value.account);
};

return { __sfc: true,props, messengerText, messengerStyle, setMessengerStyle, textEl, isShowTooltip, copyValue, BaseChip, SvgStar, SvgTrue, SvgFalse, BaseAutocomplete, BaseSelect, Status, MessengerSelect, BaseTooltip, PhoneNumberInput, BaseButton, BaseDateTimePicker, TagSelect, AFFILIATE_INFO_EDIT_TYPE, AFFILIATE_INFO_TYPE, BaseChipCollection, subYears, BaseInput, ListItemText, BaseInputNumber }
}

})